import { render, staticRenderFns } from "./_SendMailConfirmableDialog.vue?vue&type=template&id=2d0f2d0e&"
import script from "./_SendMailConfirmableDialog.vue?vue&type=script&lang=js&"
export * from "./_SendMailConfirmableDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports